import React from "react";
import { PageWrapper, TableWrapper } from "../../layout";
import { BarLoader, Button } from "../../widgets";

function SettlementDetails(props) {
  const {
    inputProps,
    state,
    heading,
    templateString,
    downloadExcel,
    handleChange,
    onSortToggle,
  } = props;

  const { headerLoader, content, totalItems } = inputProps;
  const {
    pageNo, rowsPerPage, sortBy, selected,
  } = state;

  return (
    <div className="pageContainer">
      <PageWrapper>
        <PageWrapper.Header heading={heading} showBackArrow hideS>
          <div className="btn-wrapper">
            <Button
              disable={false}
              onClick={() => {
                downloadExcel();
              }}
              buttonText="Export"
            />
          </div>
        </PageWrapper.Header>
        <BarLoader scope="header" />
        <TableWrapper
          content={!headerLoader && content}
          pageNo={pageNo}
          selected={selected}
          uniqueKey="uniqKey"
          rowsPerPage={rowsPerPage}
          count={totalItems}
          handleChange={handleChange}
          templateString={templateString}
          selectionAllowed={false}
          onSortToggle={onSortToggle}
          sortBy={sortBy}
        />
      </PageWrapper>
    </div>
  );
}

export default SettlementDetails;
